export default __webpack_public_path__ + "static/media/terapia.40b96ead.jpg";